import React, { useState } from 'react';
import { message } from 'antd';
import { ContactServices } from '../services/ContactServices';
import '../assets/styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    correo: '',
    telefono: '',
    mensaje: '',
    categoria: 'General'
  });
  
  const [loading, setLoading] = useState(false);
  
  // Categorías disponibles
  const categorias = [
    { value: 'General', label: 'Consulta General' },
    { value: 'Productos', label: 'Información de Productos' },
    { value: 'Precios', label: 'Consulta de Precios' },
    { value: 'Envíos', label: 'Información de Envíos' },
    { value: 'Facturación', label: 'Facturación y Pagos' },
    { value: 'Soporte', label: 'Soporte Técnico' },
    { value: 'Otros', label: 'Otros' }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Validar campos requeridos
      if (!formData.nombre || !formData.correo || !formData.telefono || !formData.mensaje) {
        message.error('Por favor, completa todos los campos requeridos');
        return;
      }
      
      // Validar formato de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.correo)) {
        message.error('Por favor, ingresa un email válido');
        return;
      }
      
      // Enviar formulario
      const response = await ContactServices.sendContactForm(formData);
      
      if (response.success) {
        message.success('¡Mensaje enviado exitosamente! Te enviaremos una confirmación por email.');
        
        // Limpiar formulario
        setFormData({
          nombre: '',
          correo: '',
          telefono: '',
          mensaje: '',
          categoria: 'General'
        });
      }
    } catch (error) {
      console.error('Error sending contact form:', error);
      message.error(error.message || 'Error al enviar el mensaje. Por favor, intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-info">
          <h2>Información de Contacto</h2>
          <p>No dudes en ponerte en contacto con nosotros a través de cualquiera de los siguientes métodos:</p>
          <ul>
            <li><strong>Teléfono:</strong> 03514235308</li>
            <li><strong>Correo:</strong> info@mercadodelagua.com</li>
          </ul>
          
        </div>

        <div className="contact-form-section">
          <h2>Te contactamos</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
                placeholder=" "
              />
              <label htmlFor="nombre">Nombre</label>
            </div>
            <div className="form-group">
              <input
                type="email"
                id="correo"
                name="correo"
                value={formData.correo}
                onChange={handleChange}
                required
                placeholder=" "
              />
              <label htmlFor="correo">Correo</label>
            </div>
            <div className="form-group">
              <input
                type="tel"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                required
                placeholder=" "
              />
              <label htmlFor="telefono">Teléfono</label>
            </div>
            <div className="form-group">
              <select
                id="categoria"
                name="categoria"
                value={formData.categoria}
                onChange={handleChange}
                required
                className="form-select"
              >
                {categorias.map(cat => (
                  <option key={cat.value} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </select>
              <label htmlFor="categoria">Categoría</label>
            </div>
            <div className="form-group">
              <textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                required
                placeholder=" "
              ></textarea>
              <label htmlFor="mensaje">Mensaje</label>
            </div>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Mensaje'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;

